// extracted by mini-css-extract-plugin
export default {"focus":"ScrollRoute_focus__gWQf1","focus-animation":"ScrollRoute_focus-animation__RDj6r"};